var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 7.375L2.5 28.4464L23.0882 36.2966L31.0714 56.5417L52.5 7.375ZM31.3029 43.5291L26.9526 32.4967L15.7331 28.2188L42.9803 16.7361L31.3029 43.5291Z",
    fill: "#D1ADFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 7.375L2.5 28.4464L23.0882 36.2966L31.0714 56.5417L52.5 7.375ZM31.3029 43.5291L26.9526 32.4967L15.7331 28.2188L42.9803 16.7361L31.3029 43.5291Z",
    fill: "url(#paint0_linear_3_50)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_50",
    x1: 2.5878,
    y1: 56.5417,
    x2: 55.9572,
    y2: 52.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E71E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#8017F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BC0E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerGradient);
export default __webpack_public_path__ + "static/media/pointer-gradient.dc03210e.svg";
export { ForwardRef as ReactComponent };